import { ContactDataType } from './contact-data-type';

export class DialogContactsData {
    public constructor(public dataType: ContactDataType) {}

    /**
     * Liste des adresses e-mail du champ destinataires
     */
    toAddresses: string[] = [];

    /**
     * Liste des adresses e-mail du champ copie conforme.
     */
    ccAddresses: string[] = [];

    /**
     * Liste des adresses e-mail du champ copie conforme cachée.
     */
    cciAddresses: string[] = [];
}
